import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { OrganizationCustomerDTO } from '../../../../dto/organization/organization-customer.dto';

/**
 * Simple flat list datasource for the "customers" dropdown in the event form.
 * Fetches all non-deleted customers (up to 500) for the current organisation.
 */
export function customers(service: ComponentDataSourceService): DataSourceFunction {
  return {
    name: 'customers',
    description: 'Organisationens kundedatabase til brug i event-formularen',
    execute: (params?: LoadDataParams): Observable<any> => {
      return service['loadDataWithStandardFiltersGET'](
        'customers',
        '/organizations/customers',
        { ...(params ?? {}), pageSize: 500 } as any
      ).pipe(
        map(res => ({
          items: (res?.items ?? []) as OrganizationCustomerDTO[],
          totalCount: res?.totalCount ?? 0,
        })),
        catchError(error => {
          console.error('[customers datasource] Error fetching customers:', error);
          return of({ items: [], totalCount: 0 });
        })
      );
    }
  };
}
